import styled from "styled-components";
import {Flex} from "./flex";

export const FlexJustifyCenter = styled(Flex)`
    justify-content: center;
`;
